var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparison(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 12.6667C5.33333 13.403 4.73638 14 4 14C3.26362 14 2.66667 13.403 2.66667 12.6667C2.66667 11.9303 3.26362 11.3333 4 11.3333C4.73638 11.3333 5.33333 11.9303 5.33333 12.6667ZM5.33333 12.6667H10.6667C11.403 12.6667 12 12.0697 12 11.3333V8.66667M10.6667 3.33333C10.6667 4.06971 11.2636 4.66667 12 4.66667C12.7364 4.66667 13.3333 4.06971 13.3333 3.33333C13.3333 2.59695 12.7364 2 12 2C11.2636 2 10.6667 2.59695 10.6667 3.33333ZM10.6667 3.33333H5.33333C4.59695 3.33333 4 3.93029 4 4.66667V7.33333M14 10L12.2357 8.10487C12.1055 7.96504 11.8945 7.96504 11.7643 8.10487L10 10M6 6L4.2357 7.89513C4.10553 8.03496 3.89447 8.03496 3.7643 7.89513L2 6",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparison);
export default __webpack_public_path__ + "static/media/comparison.7b6538ca4f9fa27f38a81f82c251ed43.svg";
export { ForwardRef as ReactComponent };